export default __webpack_public_path__ + "static/media/tool3.035eec5b.png";